import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Container, Row, Col, Card, CardBody, Spinner, Button } from 'reactstrap'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import CalendarLocale from '@fullcalendar/core/locales/pt-br'
import Select from '../../../components/Template/Input/Select'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { getProducts, getProductsFromOikos } from '../../../store/ducks/technicalDep'
import moment from 'moment'
import {MaterialReactTable} from 'material-react-table'
import currencyFormatter from '../../../utils/currencyFormatter'
import * as XLSX from 'xlsx'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { Box, Typography, Modal } from '@mui/material'
import { getReceitasFromOikos } from '../../../utils/fc'
import qs from 'qs'
import oikosApi from '../../../services/oikos'
import '../../../assets/css/custom-fc-event.css'
import Legenda from '../../../components/Legenda/Legenda'
import ContasAReceber from './ContasAReceber'


export default class Receitas extends Component {
  constructor(props) {
    super(props)
    this.state = {
      calendarDateOption: 'Data limite faturamento',
      isModalOpen: false,
      isCalendar: true,
      isContasAReceber: false,
      receitas: [],
      recInfo: {}
    }
  }

  handleReceitas = async () => {
    const rec = await getReceitasFromOikos()
    this.setState({receitas: rec})
  }

  componentDidMount() {
    this.handleReceitas()
  }

  handleOpenModal = () => this.setState({isModalOpen: true});
  handleCloseModal = () => this.setState({isModalOpen: false});

  getProductResume = (e) => {
    this.setState({
      recInfo: {
        rec_ep: e.event._def.extendedProps.rec_ep,
        rec_vlrBru: e.event._def.extendedProps.rec_vlrBru,
        rec_vlrLiq: e.event._def.extendedProps.rec_vlrLiq,
        rec_fat: e.event._def.extendedProps.rec_fat,
        rec_risco: e.event._def.extendedProps.rec_risco,
        rec_dtQuitAtual: e.event._def.extendedProps.rec_dtQuitAtual,
        rec_dtQuitIni: e.event._def.extendedProps.rec_dtQuitIni,
        rec_dtNfPrev: e.event._def.extendedProps.rec_dtNfPrev,
        recProjeto: e.event._def.extendedProps.recProjeto,
      }
    });
  }

  render() {
    const { calendarDateOption } = this.state
    const receitasLoaded = this.state.receitas.length > 0

    return (
      <div className="page-content">
        <Container fluid>

            <Breadcrumbs
              title="Receitas"
              breadcrumbItems={[]}
            />

            <Row className="mb-3 justify-content-between">

              <div className='d-flex justify-content-between'>
                <Button
                  className='mr-2'
                  style={{backgroundColor: this.state.isCalendar ? '#4e515e' : '#74788d'}}
                  onClick={() => {
                    this.setState({
                      isCalendar: true,
                      isContasAReceber: false,
                    })
                  }}
                >
                  Calendário
                </Button>
                <Button
                  className='mr-2'
                  style={{backgroundColor: this.state.isContasAReceber ? '#4e515e' : '#74788d'}}
                  onClick={() => {
                    this.setState({
                      isCalendar: false,
                      isContasAReceber: true,
                    })
                  }}
                >
                  Contas a Receber
                </Button>
              </div>
              {this.state.isCalendar &&
                <Col sm={2} md={3} style={{ zIndex: 2 }}>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={false}
                    defaultValue={{
                      value: 'Data limite faturamento',
                      label: 'Data limite faturamento',
                    }}
                    options={[
                      {
                        value: 'Data prevista quitação',
                        label: 'Data prevista quitação',
                      },
                      {
                        value: 'Data limite faturamento',
                        label: 'Data limite faturamento',
                      },
                    ]}
                    onChange={({ value }) => this.setState({ calendarDateOption: value })}
                  />
                </Col>
              }
            </Row>

            {this.state.isCalendar && (
              receitasLoaded ? (
                <>
                  <div style={{marginTop: "32px"}}>
                    <Legenda objLegenda={{"Faturada": "blue", "Fatura atrasada" : "red", "No prazo mas não faturada" : "green"}}/>
                  </div>
                  <Row>
                    <Col>
                      <Card>
                        <CardBody>
                          <FullCalendar
                            eventClick={(e)=>{this.getProductResume(e); this.handleOpenModal()}}
                            handleWindowResize
                            locale={CalendarLocale}
                            plugins={[dayGridPlugin]}
                            defaultView="dayGridMonth"
                            headerToolbar={{
                              left: 'prev,next today',
                              center: 'title',
                              right: 'dayGridMonth,dayGridWeek,dayGridDay',
                            }}
                            events={this.state.receitas.map((rec, index) => {
                                  // Parse the date using the Brazilian time zone
                                  const currentDate = moment().format('YYYY-MM-DD'); // get the current date without time
                                  const colorDataLimiteFat = `
                                    ${
                                      (rec.rec_fat === 1)
                                    ? 'blue'
                                    : (new Date(rec.rec_dtNfPrev) > new Date(currentDate)) ? 'green' : 'red'
                                    }
                                  `;

                                  const colorDataPrevistaQuit= `
                                    ${
                                      (rec.rec_risco === 0)
                                      ? 'blue'
                                      : (new Date(rec.rec_dtQuitAtual) > new Date(currentDate)) ? 'green' : 'red'
                                    }
                                  `;

                                  return {
                                    id: index,
                                    title: rec.rec_ep,
                                    rec_vlrBru: rec.rec_vlrBru,
                                    rec_vlrLiq: rec.rec_vlrLiq,
                                    rec_fat: rec.rec_fat,
                                    rec_risco: rec.rec_risco,
                                    rec_dtQuitAtual: rec.rec_dtQuitAtual,
                                    rec_dtQuitIni: rec.rec_dtQuitIni,
                                    rec_dtNfPrev: rec.rec_dtNfPrev,
                                    rec_ep: rec.rec_ep,
                                    recProjeto: rec.recProjeto,
                                    allDay: true,
                                    start:
                                      calendarDateOption === 'Data limite faturamento' ? rec.rec_dtNfPrev
                                      : calendarDateOption === 'Data prevista quitação' ? rec.rec_dtQuitAtual
                                      : null,
                                    color:
                                      calendarDateOption === 'Data limite faturamento' ? colorDataLimiteFat
                                      : calendarDateOption === 'Data prevista quitação' ? colorDataPrevistaQuit
                                      : null,
                                  }})}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </>
              ) : (
                <div className="centered">
                  <Spinner />
                </div>
              )
            )}

            {this.state.isContasAReceber && (
              <div style={{marginTop: "50px"}}>
                <ContasAReceber />
              </div>
            )}

        </Container>
        <Modal
          open={this.state.isModalOpen}
          onClose={this.handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 600,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Resumo da receita
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <span>Receita: {this.state.recInfo.rec_ep}</span><br/>
              <span>Projeto: {this.state.recInfo.recProjeto}</span><br/>
              <span>Valor Bruto: {currencyFormatter.format(this.state.recInfo.rec_vlrBru)}</span><br/>
              <span>Valor Líquido: {currencyFormatter.format(this.state.recInfo.rec_vlrLiq)}</span><br/>
              <span>Faturado: {this.state.recInfo.rec_fat === 1 ? 'SIM' : 'NÃO'}</span><br/>
              <span>Data de quitação inicial: {moment(this.state.recInfo.rec_dtQuitIni).format('DD/MM/YYYY')}</span><br/>
              <span>Data de quitação atualizada: {moment(this.state.recInfo.rec_dtQuitAtual).format('DD/MM/YYYY')}</span><br/>
              <span>Data limite faturamento: {moment(this.state.recInfo.rec_dtNfPrev).format('DD/MM/YYYY')}</span><br/>
              <span>Risco: {this.state.recInfo.rec_risco}</span><br/>
            </Typography>
            <div style={{display: 'flex', justifyContent: 'end', marginTop: '20px'}}>
              <Button onClick={this.handleCloseModal}>Voltar</Button>
            </div>
          </Box>
        </Modal>
      </div>
    )
  }
}
